
import ThicknessImage from "../../assets/measurementImages/thickness.jpg";
import LineCutImage from "../../assets/measurementImages/linecut.jpg";
import MarkingImage from "../../assets/measurementImages/marking.jpg";
import CutImage from "../../assets/measurementImages/cut.jpg";
import FitImage from "../../assets/measurementImages/fit.jpg";


export function MeasurementImage(key){
    key = key.toLowerCase();

    if (/thickness/.test(key)) {
        return ThicknessImage;
    }
    if (/linecut/.test(key)) {
        return LineCutImage;
    }
    if (/marking/.test(key)) {
        return MarkingImage;
    }
    if (/cut/.test(key)) {
        return CutImage;
    }
    if (/fit/.test(key)) {
        return FitImage;
    }
    if (/kerf/.test(key)) {
        return FitImage;
    }
    return null;
}